import { NavigationModeType, NavigationThemeType } from './themes';

export const Application = {
  shop: 'shop',
  pcom: 'pcom',
  default: 'default'
} as const;

export type ApplicationType = (typeof Application)[keyof typeof Application];

export type ContextualIconProps = {
  locale: string;
  app: ApplicationType;
  mode: NavigationModeType;
  theme: NavigationThemeType;
  isNavigationLoaded: boolean;
};
export type ContextualIconResponse = {
  leftIcons: HTMLElement | null;
  rightIcons: HTMLElement | null;
};

export enum DrawerStatusValues {
  startOpening = 'startOpening',
  startClosing = 'startClosing',
  finishOpening = 'finishOpening',
  finishClosing = 'finishClosing'
}

export type DrawerStatusTypes = (typeof DrawerStatusValues)[keyof typeof DrawerStatusValues];
